import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Users, Building2, MapPin, BookUser } from "lucide-react";
import { useClaimDirectory } from "@/hooks/use-claim-directory-links";
import { DirectoryGroup } from "./DirectoryGroup";
import { DirectoryDialogs } from "./DirectoryDialogs";
import type { ClaimDetailed } from "@/api/generated/client/models";

interface SidebarLinkedEntitiesSectionProps {
    claim: ClaimDetailed;
}

export function SidebarLinkedEntitiesSection({ claim }: SidebarLinkedEntitiesSectionProps) {
    const directory = useClaimDirectory(claim);

    return (
        <Card>
            <CardHeader className="pb-3">
                <div className="flex items-center gap-2 text-sm font-semibold">
                    <BookUser className="h-4 w-4 text-muted-foreground" />
                    Directory
                </div>
            </CardHeader>
            <CardContent className="space-y-5">
                <DirectoryGroup
                    {...directory.contacts}
                    canManage={directory.canManage}
                    icon={Users}
                    title="Contacts"
                    placeholder="Search contacts..."
                    createNewLabel="Create new contact"
                    dialogTitle="Link or create contact"
                    emptyMessage="No contacts linked."
                />
                <DirectoryGroup
                    {...directory.organizations}
                    canManage={directory.canManage}
                    icon={Building2}
                    title="Organizations"
                    placeholder="Search organizations..."
                    createNewLabel="Create new organization"
                    dialogTitle="Link or create organization"
                    emptyMessage="No organizations linked."
                />
                <DirectoryGroup
                    {...directory.properties}
                    canManage={directory.canManage}
                    icon={MapPin}
                    title="Properties"
                    showBadge={false}
                    placeholder="Search properties..."
                    createNewLabel="Create new property"
                    dialogTitle="Link or create property"
                    emptyMessage="No properties linked."
                />
            </CardContent>

            <DirectoryDialogs
                claimId={claim.id}
                dialogs={directory.dialogs}
                canCreate={directory.canManage}
            />
        </Card>
    );
}
